import React from "react";
import { ArrowUpRight } from "react-feather";
import { BsGraphUp } from "react-icons/bs";
import {
  FaCalendarAlt,
} from "react-icons/fa";

const RetentionRunMiniRow = ({ run, active, onClick }) => {

  const smsCost =
    run.sms_cost || 0;

  const recoveredRevenue =
    run.recovered_revenue || 0;

  const roi =
    smsCost > 0
      ? (recoveredRevenue / smsCost).toFixed(1)
      : 0;

  

  const formatDate = (dateInput) => {

    const date =
        dateInput instanceof Date
            ? dateInput
            : new Date(dateInput);

    const days = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
    ];

    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    return `${days[date.getDay()]}, ${date.getDate()} ${
        months[date.getMonth()]
    } ${date.getFullYear()}`;
};

  return (

    <div
      onClick={() => onClick(run)}
      className="d-flex justify-content-between align-items-start p-3 pointer mb-2"
      style={{
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        transition: "all .2s ease",
      }}
    >

      {/* LEFT */}
      <div className="flex-grow-1">

        {/* TITLE */}
        <div className="d-flex align-items-center gap-2 mb-1">

          <div className="mb-0 fw-semibold font1">

            Recovery Run #{run.run_li_id}

          </div>

           <span
              style={{
                backgroundColor:
                        run.status === "executed"
                          ? "#22c55e"
                          : "#f59e0b",
                color: "#fff",
                borderRadius: "999px",
                padding: "0.1em 0.7em",
                fontSize: "0.68em",
                fontWeight: 600,
              }}
            >
              {run.status === "executed"
                ? "Completed"
                : "Processing"}
            </span>

        </div>

        {/* META */}
        <p className="text-muted font8 mb-2 hide">

          KES {smsCost} spent •{" "}

          <span className="fw-semibold text-success">
            {roi}× return
          </span>

        </p>

        {/* STATS */}
        <div className="d-flex align-items-center text-muted font8 gap-3">

          <div className="d-flex align-items-center gap-1">

            <FaCalendarAlt size={12} />

            <span>
              {formatDate(run.created_at)}
            </span>

          </div>

          <div className="d-flex align-items-center gap-1">

            <BsGraphUp size={12} />

            <span className="font-bold">

              +KES{" "}
              {recoveredRevenue.toLocaleString()}

            </span>

          </div>

        </div>

      </div>

      {/* ACTION */}
      <button
        className="btn btn-sm p-1 border-0"
        style={{
          background: "transparent"
        }}
      >
        <ArrowUpRight size={14} />
      </button>

    </div>
  );
};

export default RetentionRunMiniRow;